var utils = require('util');
var ElementView = require('./ElementView');
var PartCache = require('../Models/PartCache');

var FOLDER = '3DModels/';


var PartView = module.exports = function(model, parentHeight, parentLength, parentDepth){
    this.initPartView(model, parentHeight, parentLength, parentDepth);
};

utils.inherits(PartView, ElementView);

PartView.prototype.initPartView = function(model, parentHeight, parentLength, parentDepth) {

    this.init(model);

    this.initView();

    this.cache = new PartCache();

    this.parentHeight = parentHeight;
    this.parentLength = parentLength;
    this.parentDepth = parentDepth;

    this._origin3DModel;

    this.loader = new THREE.OBJMTLLoader();

};

PartView.preloadPart = function(cache, objFile, textureFile) {
    var loader = new THREE.OBJMTLLoader();

    loader.addEventListener('load', function(event){
        var geometry = event.content;
        cache.setCache(objFile, geometry);
    });

    loader.load(FOLDER + objFile, FOLDER + textureFile);
};

PartView.factory = function(partType, model, parentHeight, parentLength, parentDepth) {
    if(partType.indexOf('long') >= 0 || model.alignment === 'length') {
        var LengthPartView = require('./LengthPartView');

        return new LengthPartView(model, parentHeight, parentLength, parentDepth);
    }else if(partType.indexOf('height') >= 0  || model.alignment === 'height') {
        var HeightPartView = require('./HeightPartView');

        return new HeightPartView(model, parentHeight, parentLength, parentDepth);
    }else if(partType.indexOf('depth') >= 0  || model.alignment === 'depth') {
        var DepthPartView = require('./DepthPartView');

        return new DepthPartView(model, parentHeight, parentLength, parentDepth);
    }else if(partType.indexOf('top') >= 0 || partType.indexOf('bottom') >= 0  || model.alignment === 'top' || model.alignment === 'bottom') {
        var UpperPartView = require('./UpperPartView');

        return new UpperPartView(model, parentHeight, parentLength, parentDepth);
    }

    return new PartView(model, parentHeight, parentLength, parentDepth);
};


PartView.prototype.loadModel3D = function(cachedGeometry){
    var that = this;

    if(cachedGeometry) {
        that.prepare3DModel(cachedGeometry.clone());
    }else {

        if(that.model.file) {
            that.loader.addEventListener('load', function(event){
                var geometry = event.content;
                that.prepare3DModel(geometry);
            });

            that.loader.load(that.cache.getBasePath() + FOLDER + that.model.file, this.cache.getBasePath() + FOLDER + that.model.textureFile);
        }else {
            that.emit('3DModelLoaded');
        }

    }

    return that;
};

PartView.prototype.prepare3DModel = function(geometry){
    var that = this;

    var scaleParameter = that._getScaleParameter(geometry);

    var modelsRotation = that.model.rotation;

    var modelsPosition = that.model.position;

    that._origin3DModel = geometry.clone();

    //console.log('position of ' + that.model.category + ': ' + that.model.position);
    geometry.scale.set(scaleParameter[0], scaleParameter[1], scaleParameter[2]);

    geometry.rotation.set(modelsRotation[0], modelsRotation[1], modelsRotation[2]);

    geometry.position.x = modelsPosition[0];
    geometry.position.y = modelsPosition[1];
    geometry.position.z = modelsPosition[2];


    that.setModel3D(geometry);

    that._applyMaterial(geometry);


};

PartView.prototype._applyMaterial = function(geometry) {
    var that = this;

    var childrenIndex = getChildrenIndex();

    if(Detector.webgl) {
        addNormalMaps();
    }else {
        var material = geometry.children[childrenIndex].children[0].material;
        geometry.children[childrenIndex].children.forEach(function(child, index) {
            geometry.children[childrenIndex].children[index].material = new THREE.MeshLambertMaterial(material);
            that.emit('3DModelLoaded');

        });
    }

    if(that.model.category === 'PANEL') {
        geometry.children[childrenIndex].children[0].renderDepth = -20;
        geometry.children[childrenIndex].children[0].material.ambient = new THREE.Color("#111111");
        geometry.children[childrenIndex].children[0].material.emissive = new THREE.Color("#555555");
        geometry.children[childrenIndex].children[0].material.specular = new THREE.Color("#555555");
    }else if(that.model.category === 'EDGE_PROTECTION'){
        geometry.children[childrenIndex].children[0].renderDepth = 5;
    }else if(that.model.category === 'PROFILE'){
        geometry.children[childrenIndex].children[0].renderDepth = 0;
    } else if (that.model.category === 'CORNER') {
        geometry.children[childrenIndex].children[0].renderDepth = 20;
    } else {
        geometry.children[childrenIndex].children[0].renderDepth = 10;
    }


    if(that.model.chromeMaterial) {
        setColor('#8a8984');
    }else if(that.model.aluMaterial) {
        setColor('#a1a09a');
    }else if(that.model.woodMaterial){
        setColor('#29251d');
    }


    function addNormalMaps() {
        if(geometry.children[childrenIndex].children[0].material &&  geometry.children[childrenIndex].children[0].material.normalMap === null) {
            if(('normalMaps' in that.model) && Array.isArray(that.model.normalMaps) && that.model.normalMaps.length > 0) {
                that.model.normalMaps.forEach(function(normalMap, index) {
                    THREE.ImageUtils.loadTexture(that.cache.getBasePath() + FOLDER + normalMap, null, function(texture) {
                        if(that.model.category === 'PANEL') {
                            texture.repeat.set(1, 1);
                            texture.wrapS = THREE.RepeatWrapping;
                            texture.wrapT = THREE.RepeatWrapping;


                        }

                        geometry.children[childrenIndex].children[index].material.normalMap = texture;

                        geometry.children[childrenIndex].children[index].material.needsUpdate = true;

                        if(that.model.category === 'PANEL'){
                            //geometry.children[childrenIndex].children[index].material.normalScale.set(0.25, 0.25);
                            geometry.children[childrenIndex].children[index].material.normalScale.set(0.1, 0.1);
                        }else {
                            geometry.children[childrenIndex].children[index].material.normalScale.set(1.2, 1.2);
                        }

                        that.emit('3DModelLoaded');
                    });
                });

            }else {

                geometry.children[childrenIndex].children.forEach(function(child, index) {

                    geometry.children[childrenIndex].children[index].material.normalMap = null;
                    geometry.children[childrenIndex].children[index].material.needsUpdate = true;
                });
                that.emit('3DModelLoaded');

            }
        }else {
            that.emit('3DModelLoaded');
        }

    }

    function setColor(materialColor) {
        geometry.children[childrenIndex].children.forEach(function(mesh) {
            mesh.material.color.setStyle(materialColor);
        });
    }

    function getChildrenIndex() {
        var result = 0;
        geometry.children.forEach(function(child, index){
            if((child.children.length > 0) && (child.children[0] instanceof THREE.Mesh)) {
                result = index;
            }
        });

        return result;
    }
};

PartView.prototype.scaleHeight = function(globalScale, change, keepCapBodyRatio, onCap, keepBodyHeight) {
    var that = this;
    var geometry = that.getModel3D();
    var scaleAxis = that.model.scaleAxis;
    var size = that.getDimensionsOfOrigin3DModel();

    if(that.axisMustBeScaled(scaleAxis[0])) {
        geometry.scale.x = that.scaleLengthParameter(size.x);
    }

    if(that.axisMustBeScaled(scaleAxis[1])) {
        geometry.scale.y = that.scaleHeightParameter(size.y);
    }

    if(keepCapBodyRatio || (!onCap && !keepBodyHeight)) {
        var yPosition = geometry.position.y;

        if(yPosition > 0) {
            geometry.position.y += (0.5*change);
        }else if(yPosition < 0) {
            geometry.position.y -= (0.5*change);
        }

    }else if((onCap && keepBodyHeight)){
        if(!that.model.doNotMoveOnHeightScale && !that.model.moveByChange){
            geometry.position.y *= globalScale;
        }else if(that.model.moveByChange) {
            geometry.position.y += change;
        }

    }

    that.model.position[1] = geometry.position.y;

    if(that.axisMustBeScaled(scaleAxis[2])) {
        geometry.scale.z = that.scaleDepthParameter(size.z);
    }

    that.setModel3D(geometry);
};

PartView.prototype.scaleLength = function(globalScale, change) {
    var that = this;

    var geometry = that.getModel3D();
    var scaleAxis = that.model.scaleAxis;
    var size = that.getDimensionsOfOrigin3DModel();


    if(that.axisMustBeScaled(scaleAxis[0])) {
        geometry.scale.x = that.scaleLengthParameter(size.x);

    }

    if(that.axisMustBeScaled(scaleAxis[1])) {
        geometry.scale.y = that.scaleHeightParameter(size.y);
    }

    if(that.axisMustBeScaled(scaleAxis[2])) {
        geometry.scale.z = that.scaleDepthParameter(size.z);
    }

    var xPosition = geometry.position.x;

    if(xPosition > 0) {
       geometry.position.x += (0.5*change);
    }else if(xPosition < 0) {
        geometry.position.x -= (0.5*change);
    }

    //geometry.position.x *= globalScale;

    that.model.position[0] = geometry.position.x;

    that.setModel3D(geometry);
};

PartView.prototype.scaleDepth = function(globalScale, change) {
    var that = this;

    var geometry = that.getModel3D();
    var scaleAxis = that.model.scaleAxis;
    var size = that.getDimensionsOfOrigin3DModel();

    if(that.axisMustBeScaled(scaleAxis[0])) {
        geometry.scale.x = that.scaleLengthParameter(size.x);
    }

    if(that.axisMustBeScaled(scaleAxis[1])) {
        geometry.scale.y = that.scaleHeightParameter(size.y);
    }


    if(that.axisMustBeScaled(scaleAxis[2])) {
        geometry.scale.z = that.scaleDepthParameter(size.z);
    }

    var zPosition = geometry.position.z;

    if(zPosition > 0) {
        geometry.position.z += (0.5*change);
    }else if(zPosition < 0) {
        geometry.position.z -= (0.5*change);
    }

    //geometry.position.z *= globalScale;

    that.model.position[2] = geometry.position.z;


    that.setModel3D(geometry);

};

PartView.prototype.updateLength = function(newLength) {
    this.parentLength = newLength;
};

PartView.prototype.updateDepth = function(newDepth) {
    this.parentDepth = newDepth;
};

PartView.prototype.getDimensionsOfOrigin3DModel = function() {
    var that = this;

    var bb = new THREE.BoundingBoxHelper(that._origin3DModel);
    bb.update();
    return bb.box.size();
};

PartView.prototype.axisMustBeScaled = function(axis) {
    return axis !== 0;
};

PartView.prototype._getScaleParameter = function(object3D) {
    var that = this;
    var scaleParameter = [1, 1, 1];
    var scaleAxis = that.model.scaleAxis;
    var boundingBox = new THREE.BoundingBoxHelper(object3D);
    var size;
    boundingBox.update();
    size = boundingBox.box.size();



    if(that.axisMustBeScaled(scaleAxis[0])) {
        scaleParameter[0] = that.scaleLengthParameter(size.x);
    }

    if(that.axisMustBeScaled(scaleAxis[1])) {
        scaleParameter[1] = that.scaleHeightParameter(size.y);
    }

    if(that.axisMustBeScaled(scaleAxis[2])) {
        scaleParameter[2] = that.scaleDepthParameter(size.z);
    }


    return scaleParameter;
};

PartView.prototype.updateHeight = function(newParentHeight) {
    this.parentHeight = newParentHeight;
};

PartView.prototype.scaleHeightParameter = function(size) {
    return this.parentHeight/size;
};

PartView.prototype.scaleLengthParameter = function(size) {
    return this.parentLength/size;
};

PartView.prototype.scaleDepthParameter = function(size) {
    return this.parentDepth/size;
};


PartView.prototype.getOriginal3DModel = function() {
    return this._origin3DModel;
};

PartView.prototype.getParentLength = function() {
    return this.parentLength;
};

PartView.prototype.getParentDepth = function() {
    return this.parentDepth;
};

PartView.prototype.getParentHeight = function() {
    return this.parentHeight;
};


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/PartView.js